import { render, staticRenderFns } from "./CartCTA.vue?vue&type=template&id=191c755c&"
import script from "./CartCTA.vue?vue&type=script&lang=js&"
export * from "./CartCTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports